<template>
  <div>
    <v-snackbar v-if="index != -1"
      :top="(notifications[index] && notifications[index].position == 'top')"
      :bottom="(notifications[index] && !notifications[index].position)"
      :right="(notifications[index] && (!notifications[index].position || notifications[index].position == 'bottom')) ? 'right' : false"
      :multi-line="(notifications[index] && notifications[index].multiLine) ? notifications[index].multiLine : false"
      :timeout="(notifications[index] && notifications[index].timeout) ? notifications[index].timeout : 6000"
      v-model="showSnackBar"
      :color="(notifications[index] && notifications[index].color) ? notifications[index].color : 'black'"
      style="z-index: 9999 !important"
    >
      <!-- :color="notifications[index] ? notifications[index].context : 'info'" -->
      {{ notifications[index] ? notifications[index].message : ''}}
      <v-btn flat
        @click="actionNotification()"
        white--text 
        v-if="index != -1 && notifications[index].color && !notifications[index].type == 'collections'"
      >
        {{ notifications[index] ? notifications[index].action.text : ''}}
        <span v-if="index != -1">
          <v-icon color="white" right v-if="notifications[index].context == 'success'">check_circle</v-icon>
          <v-icon color="white" right v-else-if="notifications[index].context == 'info'">info</v-icon>
          <v-icon color="white" right v-else-if="notifications[index].context == 'warning'">warning</v-icon>
          <v-icon color="white" right v-else-if="notifications[index].context == 'error'">error</v-icon>
        </span>
      </v-btn>

      <!-- ce bouton ne supprime pas la notification du notification center -->
      <!-- spécial pour le notification d'alert dépassement de quota -->
      <v-btn flat
        white--text
        @click="fermeSnackBar()"
        v-if="index != -1 && notifications[index].color && notifications[index].type == 'collections'"
      >
        {{ notifications[index] ? notifications[index].action.text : ''}}
        <span v-if="index != -1">
          <v-icon right v-if="notifications[index].context == 'success'">check_circle</v-icon>
          <v-icon right v-else-if="notifications[index].context == 'info'">info</v-icon>
          <v-icon right v-else-if="notifications[index].context == 'warning'">warning</v-icon>
          <v-icon right v-else-if="notifications[index].context == 'error'">error</v-icon>
        </span>
      </v-btn>

      <v-btn flat
        :class="notifications[index].context + '--text'"
        @click="actionNotification()"
        v-if="index != -1 && !notifications[index].color"
      >
        {{ notifications[index] ? notifications[index].action.text : ''}}
        <span v-if="index != -1">
          <v-icon right v-if="notifications[index].context == 'success'">check_circle</v-icon>
          <v-icon right v-else-if="notifications[index].context == 'info'">info</v-icon>
          <v-icon right v-else-if="notifications[index].context == 'warning'">warning</v-icon>
          <v-icon right v-else-if="notifications[index].context == 'error'">error</v-icon>
        </span>
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
export default {
  data () {
    return {
      showSnackBar: false
    }
  },

  computed: {
    ...mapState('_Notifier', ['notifications', 'show']),
    ...mapGetters('_Notifier', ['index'])
  },

  methods: {
    ...mapActions('_Notifier', ['HIDE_NOTIF', 'OPEN_NOTIF']),
    ...mapMutations('_Notifier', ['SHOW']),
    actionNotification () {
      this.showSnackBar = false
      this.OPEN_NOTIF(this.index)
    },
    fermeSnackBar () {
      this.showSnackBar = false
    }
  },

  watch: {
    /**
     * pour savoir quand afficher la notification
     */
    showSnackBar (v) {
      if (v) {
        this.SHOW()
      } else {
        this.HIDE_NOTIF()
      }
    },

    show (v) {
      if (v) {
        this.showSnackBar = v
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/watcheezy/WzNotifier.vue